import { AxiosResponse } from "axios";
import { parseApiData } from "go-core/api/parseApiData";
import { getSearchSelectPage, mapToBase } from "go-core/api/searchSelectService";
import { restApi } from "../../Security/api";
import { AcceptUserTermsSecurityApi, CreateOrganizationApi } from "../../Security/types";
import { InvitationApi } from "../Organization/organizationTypes";
import { CreateLoanApi, LoanApi, OrganizationApi, OrganizationMeApi } from "../types";
import { ChangeUserPasswordFormProps, ProfileFormProps, RemoveUserAccountApi } from "./userTypes";

class userApi {
	static async verifyEmail(): Promise<AxiosResponse> {
		return restApi.post("/users/verify_email");
	}

	static async createOrganization(data: CreateOrganizationApi, params?: Record<string, any>): Promise<AxiosResponse> {
		return restApi.post("/organizations", data, { params });
	}

	static async getOrganization(organizationId: number, params?: Record<string, any>): Promise<OrganizationMeApi> {
		return parseApiData(restApi.get(`/organizations/${organizationId}`, { params }));
	}

	static async saveUser(
		userId: number,
		data: ProfileFormProps,
		params?: Record<string, any>
	): Promise<AxiosResponse> {
		return restApi.put(`/users/${userId}`, data, { params });
	}

	static async removeUser(userId: number, data: RemoveUserAccountApi): Promise<AxiosResponse> {
		return restApi.delete(`/users/${userId}`, { data });
	}

	static async generateRemoveAccountToken(): Promise<AxiosResponse> {
		return restApi.post(`/users/delete_user_confirmation_token`);
	}

	static async updateOrganizationMePatch(id: number, data: OrganizationApi, params?: Record<string, any>) {
		return restApi.patch(`/organizations/${id}`, data, { params });
	}

	static async getOrganizationsSearchSelect(
		search: string,
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		const f = mapToBase(search, params);
		const page = getSearchSelectPage(params);
		return restApi.get(`organizations/search_select?f=${f}&page=${page}`, {
			cancelToken: options?.cancelToken,
		});
	}

	static async getUsersSearchSelect(
		search: string,
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		const f = mapToBase(search, params);
		const page = getSearchSelectPage(params);
		return restApi.get(`users/search_select?f=${f}&page=${page}`, {
			cancelToken: options?.cancelToken,
		});
	}

	static async changePassword(data: ChangeUserPasswordFormProps): Promise<AxiosResponse> {
		return restApi.post("/users/change_password", data);
	}

	//USERS

	static async acceptUserTerms(id: number, data: AcceptUserTermsSecurityApi): Promise<AxiosResponse> {
		return restApi.patch(`/users/${id}`, data);
	}

	//ME

	static async getMeOrganizations(params?: Record<string, any>, options?: any): Promise<AxiosResponse> {
		return restApi.get("/me/organizations", { params, cancelToken: options?.cancelToken });
	}

	static async getMeInvitations(
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<InvitationApi[]> {
		return parseApiData(restApi.get("/me/invitations", { params, cancelToken: options?.cancelToken }));
	}

	static async acceptMeInvitation(inviteId: number): Promise<AxiosResponse> {
		return restApi.post(`/me/invitations/${inviteId}/accept`);
	}

	static async rejectMeInvitation(inviteId: number): Promise<AxiosResponse> {
		return restApi.post(`/me/invitations/${inviteId}/reject`);
	}

	static async createLoan(data: CreateLoanApi): Promise<LoanApi> {
		return parseApiData(restApi.post(`/loans?include=partner`, data));
	}

	static async findOrganizationLoanByReferenceId(
		referenceId: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<LoanApi> {
		return parseApiData(
			restApi.get(`/loans/find_by_reference_id/${referenceId}?include=partner,organization,items`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	}
}

export { userApi };
